import {
  FilterConfig,
  LocationAlarmStatus,
  TimePeriod,
} from '@hakimo-ui/hakimo/types';
import { LocationIncidentsFilterValues } from './types';

export const filterConfigs: FilterConfig[] = [
  {
    type: 'location',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
];

export const defaultFilterValues: LocationIncidentsFilterValues = {
  location: {
    values: [],
    negative: false,
  },
  time: {
    period: TimePeriod.PAST_24_HOURS,
    customRangeStart: 0,
    customRangeEnd: 0,
  },
  status: {
    values: ['resolved' as LocationAlarmStatus],
    negative: false,
  },
};

export const LOCATION_INCIDENTS_QUERY_INTERVAL = 10000;
